import React, { useState } from 'react';

import TabMenu from '../../components/Generic/TabMenu';

//Tabs
import TabDashboard from './tabDashboard';
import TabIcons from './tabIcons';
import TabDropDown from './tabDropDown';
import TabExpand from './tabExpand';
import TabForm from './tabForm';
import TabInput from './tabInput';
import TabPref from './tabPref';
import TabOthers from './tabOthers';

import Layout from '../../components/Layout/Layout';

import './index.css';

const Devops: React.FC = () => {

    const tabs = [
        { name: 'dashboard', label: "Dashboard" },
        { name: 'icons', label: "Ícones" },
        { name: 'dropdown', label: "Dropdown" },
        { name: 'expand', label: "Expand" },
        { name: 'form', label: "Formulário" },
        { name: 'input', label: "Campos" },
        { name: 'pref', label: "Preferências" },
        { name: 'others', label: "Outros" },
    ]

    const [selectedTab, setSelectedTab] = useState(tabs[0].name);

    return (
        <Layout pageTitle='DevOps'>

            <TabMenu items={tabs.map(t => { return { ...t, active: selectedTab === t.name, onClick: () => setSelectedTab(t.name) } }) as any} />
            {
                selectedTab === "dashboard" && <TabDashboard />
            }
            {
                selectedTab === "icons" && <TabIcons />
            }
            {
                selectedTab === "dropdown" && <TabDropDown />
            }
            {
                selectedTab === "expand" && <TabExpand />
            }
            {
                selectedTab === "form" && <TabForm />
            }
            {
                selectedTab === "input" && <TabInput />
            }
            {
                selectedTab === "pref" && <TabPref />
            }
            {
                selectedTab === "others" && <TabOthers />
            }
        </Layout>
    );
}

export default Devops;